import React from 'react';
import { CheckCircle } from '@mui/icons-material'; 
import './SuccessOverlay.css'; 

const SuccessOverlay = (props) => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className="overlay">
      <div className="overlay-content" onClick={props.onBackdropPress}>
        {!props.noTick && (
          <CheckCircle style={{ fontSize: '24px', color: '#003366' }} />
        )}
        <span className="overlay-text">{props.type}</span>
      </div>
    </div>
  );
};

export default SuccessOverlay;
